import { BaseClass } from 'digicon-events-base';

export class FileUploader extends BaseClass {
	constructor(props) {
		super(props);
		this.props = props;
		this.sliceSize = null;
		this.zippedSliceSize = null;
		this.zipUpload = null;
		this.filesToUpload = null;
		this.fileIndex = null;
		this.file = null;
		this.reader = null;
		this.fileContent = [];
		this.result = null;
	}

	upload(key, files, subpath) {
		if (typeof files === 'undefined') {
			this.trigger('onNoFileSelected');
			return;
		}
		files[0] = files[0].filter((file) => {
			return typeof file !== 'undefined';
		});
		this.filesToUpload = files;
		this.result = [];
		for (let i = 0; i < files[0].length; i++) {
			this.reader = new FileReader();
			let isLast = false;
			if (i == files[0].length - 1) {
				isLast = true;
			}
			this._upload_file(key, i, subpath, isLast);
		}
	}

	_upload_file(key, fileIndex, subpath, isLast) {
		this.fileIndex = fileIndex;
		this.file = this.filesToUpload[0][fileIndex];
		if (typeof this.file !== 'undefined') {
			this._setUploadOptions();
			this._upload_file_slice(key, 0, subpath, isLast, fileIndex);
		}
	}

	_upload_file_slice(key, sliceStart, subpath, isLast, fileIndex) {
		let next_slice = sliceStart + this.sliceSize + 1;
		let blob = this.file.slice(sliceStart, next_slice);

		this.reader.onloadend = (e) => {
			if (e.target.readyState !== FileReader.DONE) {
				return;
			}

			let uploadSucceed = (data) => {
				let size_done = sliceStart + this.sliceSize;
				let percent_done = Math.floor((size_done / this.file.size) * 100);
				if (next_slice < this.file.size) {
					// Update upload progress
					this.trigger('onUploadProgress', percent_done);
					// More to upload, call function recursively
					this._upload_file_slice(key, next_slice, subpath);
				} else {
					this.result.push(data.path + '/' + data.realFileName);
					// Update upload progress
					this.trigger('onUploadProgress', 100);
					// Jump to next file
					this.fileIndex++;
					if (this.fileIndex === this.filesToUpload.length) {
						this.trigger('onUploadCompleted', this.result);
					} else {
						this._upload_file(key, this.fileIndex, subpath);
					}
				}
			};

			let uploadFailed = (error) => {
				this.trigger('onUploadFailed', error);
			};
			this.fileContent.push({
				filename: this.filesToUpload[0][fileIndex].name,
				key: `WE0${fileIndex + 1}`,
				value: e.target.result.indexOf(',') === -1 ? '' : e.target.result.substr(e.target.result.indexOf(',') + 1), //we remove the header "data:xxx;base64",
			});
			if (isLast) {
				const files = this.fileContent;
				let data = {
					username: sessionStorage.lcoe_loginhash,
					form_id: 1,
					project_id: sessionStorage.lcoe_selected,
					input: {
						id: 0,
						data: files
					}
				};
				this.uploadCall(data, uploadSucceed, uploadFailed);
			}
		};

		this.reader.readAsDataURL(blob);
	}


	async uploadCall(data, uploadSucceed, uploadFailed) {
		let rawResponse = await fetch(`${location.href}webresources/lcoeF3/setInput`, {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		});
		const result = await rawResponse.json();
		if (result.status === 200) {
			uploadSucceed(result.data);
			this.trigger('onUploadCompleted', this.result);
		} else {
			uploadFailed(result.message);
		}
	}


	_setUploadOptions() {
		if (typeof this.props === 'undefined') {
			this.props = {};
		}
		if (typeof this.props.sliceSize === 'undefined') {
			this.sliceSize = 1024 * 1024;
		} else {
			this.sliceSize = this.props.sliceSize;
		}
		if (typeof this.props.zippedSliceSize === 'undefined') {
			this.zippedSliceSize = 4 * this.sliceSize;
		} else {
			this.zippedSliceSize = this.props.zippedSliceSize;
		}
		if (typeof this.props.zipUpload === 'undefined') {
			this.zipUpload = (this.file.size > (4 * this.sliceSize)) ? true : false;
		} else {
			this.zipUpload = this.props.zipUpload;
		}
		this.sliceSize = Math.min(this.file.size, (this.zipUpload === true) ? this.zippedSliceSize : this.sliceSize);
	}
}
